import { computed, ref, watch } from 'vue';
import { useField } from 'vee-validate';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue';
import axios from 'axios';


export default {
  __name: 'PickADoctor',
  props: {
    doctorsStatus: {
        type: String,
        required: true,
    },
    setStatus: {
        type: Function,
        required: true,
    },
    setSchedule: {
        type: Function,
        required: true,
    },
    productId: {
        type: Number,
        required: true,
    },
    doctors: {
        type: Array,
        required: true,
    },
},
  emits: ['update:modelValue'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props;

function processData(data) {
    let result = {};

    data.forEach((pair) => {
        let date = pair[0].split(' ')[0];
        let endTime = pair[1].split(' ')[1];

        if (!result[date]) {
            result[date] = {};
        }

        result[date][endTime] = 'available';
    });

    return result;
}




const { value } = useField('selectedDoctor');
const { value: selectedCallDateValue } = useField('selectedConsultationDate');
const additionalInfoOpen = ref(false);

const selectedDoctor = computed(() => {
    return value.value ? value.value : null;
});

const fetchDoctorData = async () => {
    props.setStatus('loading');

    const data = new FormData();
    data.append('action', 'wizyta_terminy');
    data.append('prod', props.productId);
    data.append('lekarz', selectedDoctor.value.id);

    axios.post(jsData.ajaxUrl, data).then(({ data }) => {
        if (data.success) {
            props.setStatus('success');
            props.setSchedule(processData(data.data));
        }
    });
};

watch(selectedDoctor, (newDoctor) => {
    console.log({ selectedDoctor });
    if (newDoctor) {
        selectedCallDateValue.value = null;
        fetchDoctorData();
    }
});

const __returned__ = { processData, props, emit, value, selectedCallDateValue, additionalInfoOpen, selectedDoctor, fetchDoctorData, computed, ref, watch, get useField() { return useField }, get Listbox() { return Listbox }, get ListboxButton() { return ListboxButton }, get ListboxOptions() { return ListboxOptions }, get ListboxOption() { return ListboxOption }, get axios() { return axios } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}